import styled from 'styled-components';
import { token, Table } from '@bynder/design-system';

export const StyledTableCell = styled(Table.Cell)`
    * > div[class^='Subtext'] {
        color: ${token.colorTextMuted};
    }
`;
